<template>
  <a :href="link ?? formattedLink" :class="['footer__link', {'--underlined': type === 'mail'}]" target="_blank">
    <Icon :id="type"/>
    <span>{{ label }}</span>
  </a>
</template>

<script>
import {Icon} from '@/components/global'

export default {
  name: 'FooterLink',
  components: {Icon},
  props: {
    label: {
      type: String,
      required: true
    },
    link: {
      type: String,
      default: null
    },
    type: {
      type: String,
      required: true,
      validator: value => ['mail', 'maps', 'phone'].includes(value)
    }
  },
  computed: {
    formattedLink() {
      switch (this.type) {
        case 'phone': return `tel:+${this.label.replaceAll(/[^0-9]/g, '')}`
        case 'mail': return `mailto:${this.label}`
        default: return ''
      }
    }
  }
}
</script>